import * as ActionTypes from "../Actions/ActionTypes";
import { updateObject } from "../Utility";

const initialState = {
  info: "N/A..."
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.AUTHENTICATION_ACTION_DUMMY_EVENT:
      return updateObject(state, { info: action.info });
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/ReduxStore/Reducers/AuthenticationReducer.js